import { Box, Typography, TextField } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { shades } from "../../theme";

const Subscribe = () => {
  return (
    <Box width="80%" margin="100px auto" textAlign="center">
      <Typography variant="h4" fontWeight="bold" marginBottom="20px">
        SUBSCRIBE TO OUR NEWSLETTER
      </Typography>
      <Typography marginBottom="20px">
        Get updates about new products and special offers!
      </Typography>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="10px"
        flexWrap="wrap"
      >
        <TextField
          placeholder="Enter your email"
          variant="outlined"
          sx={{
            minWidth: "400px",
            "@media (max-width:600px)": {
              minWidth: "220px",
            },
            "& .MuiOutlinedInput-root": {
              minHeight: "36px",
              "& input": {
                padding: "13px 20px",
              },
              "& fieldset": {
                borderColor: shades.neutral[300],
              },
              "&:hover fieldset": {
                borderColor: shades.neutral[400],
              },
            },
          }}
        />
        <CustomButton>SUBSCRIBE</CustomButton>
      </Box>
    </Box>
  );
};

export default Subscribe;
